import { GenericModelApi } from "./GenericModelApi";
import { ApiClient, ApiError, ApiSchema, FetchResponse } from "./ApiClient";
import { ReceivedAttachmentFormData, ReceivedAttachmentRelatedAttributes } from "@/formTypes/ReceivedAttachmentDataType";
import { ReceivedAttachmentFormDataKeys } from "@/generated/ReceivedAttachmentFormDataKeys";

export type ReceivedAttachmentDataType = Partial<ApiSchema["ReceivedAttachment"]["type"] & ReceivedAttachmentFormData>;

class Api extends GenericModelApi<"ReceivedAttachment", ReceivedAttachmentDataType> {

    async fetchAll(filters: any = {}, token?: string, limit: number = 20): Promise<FetchResponse<ReceivedAttachmentDataType>> {
        const selectionSet = [
            ...ReceivedAttachmentFormDataKeys.filter(k => !ReceivedAttachmentRelatedAttributes.includes(k)),
        ]

        return super.fetchAll(filters, token, limit, selectionSet);
    }

    async getByRecievedEmailId(
        recievedEmailId: string,
        selectionSet?: any,
        limit: number = 15
    ): Promise<FetchResponse<ReceivedAttachmentDataType>> {

        const fetchFunction = this.model.listAttachmentsByEmail;
        const { data, errors, nextToken: nt } = await fetchFunction({
            receivedEmailId: recievedEmailId
        }, {
            limit: limit,
            selectionSet: selectionSet,
        });

        if (errors) {
            throw new ApiError("Error al Los datos adjuntons del correo", "API_ERROR", errors);
        }

        const pageItems = (data || [])
        return {
            items: pageItems,
            nextToken: nt
        }
    }
}
const api = new Api("ReceivedAttachment", "fecha", "DESC")
export const ReceivedAttachmentApi = api